import React from 'react';
import type { BreakpointName } from '@noths/polaris-client-ribbons-base';

import * as styles from './IconBarItem.styles';

interface IconBarItemProps {
  children: React.ReactNode;
  visibleAboveBreakpoint?: Parameters<typeof styles.getVisibleAboveBreakpointStyles>[0];
  visibleBelowBreakpoint?: BreakpointName;
}

export const IconBarItem = ({
  children,
  visibleAboveBreakpoint,
  visibleBelowBreakpoint,
}: IconBarItemProps) => {
  return (
    <li
      css={[
        styles.item,
        styles.getVisibleAboveBreakpointStyles(visibleAboveBreakpoint),
        styles.getVisibleBelowBreakpointStyles(visibleBelowBreakpoint),
      ]}
    >
      {children}
    </li>
  );
};

export const IconBarItemLabel = ({ children }: { children: React.ReactNode }) => (
  <span css={styles.label}>{children}</span>
);
